module.exports = __webpack_public_path__ + "img/AE UI components.925cfc58.webp";